import { apiClient } from './baseApi';

export interface CurrentContributionResponse {
  id?: number;
  user_id?: number;
  user_name?: string;
  amount: number;
  month: string;
  year?: number;
  cycle?: number;
  date_paid?: string | null;
  status: string;
  payment_method?: string | null;
  transaction_id?: string | null;
  notes?: string | null;
  created_at?: string;
  due_date?: string;
  message?: string;
  contributions_open?: boolean;
  cycle_state?: 'setup' | 'collecting' | 'payout_ready' | 'cycle_active' | 'paused';
}

export interface InitiateMpesaResponse {
  message: string;
  checkout_request_id: string;
}

export interface ContributionHistoryResponse {
  month: string;
  total_members: number;
  paid_count: number;
  unpaid_count: number;
  total_collected: number;
  contributions: CurrentContributionResponse[];
}

export interface STKStatusResponse {
  ResponseCode?: string;
  ResponseDescription?: string;
  ResultCode?: string;
  ResultDesc?: string;
  CheckoutRequestID?: string;
  success?: boolean;
  message?: string;
}

export const ContributionApi = {
  async getCurrentContribution(): Promise<CurrentContributionResponse> {
    const response = await apiClient.get<CurrentContributionResponse>('/contribution/current');
    return response.data;
  },

  async initiateMpesaPayment(amount?: number): Promise<InitiateMpesaResponse> {
    try {
      const response = await apiClient.post<InitiateMpesaResponse>('/contribution/initiate-mpesa', {
        amount,
      });
      return response.data;
    } catch (error: any) {
      // Extract error message from response
      const errorMessage = error?.response?.data?.error || error?.response?.data?.message || error?.message || 'Failed to initiate payment';
      const errorDetails = error?.response?.data?.details;
      
      throw new Error(errorDetails ? `${errorMessage}: ${errorDetails}` : errorMessage);
    }
  },

  async querySTKStatus(checkoutRequestId: string): Promise<STKStatusResponse> {
    const response = await apiClient.get<STKStatusResponse>(
      `/contribution/query-stk-status/${checkoutRequestId}`
    );
    return response.data;
  },

  async getContributionHistory(month?: string): Promise<ContributionHistoryResponse> {
    const response = await apiClient.get<ContributionHistoryResponse>('/contribution/history', {
      params: { month },
    });
    return response.data;
  },
};

export default ContributionApi;

